<section>
  <app-breadcrumb [label]="labelBreadcrumb"></app-breadcrumb>

  <div class="section__main section__main--commissions">
    <div class="section__title section__title--mb">
      <h1>
        Estado de pagos
      </h1>
    </div>

    <div class="commission__block">
      <div class="commission__resume">
        <div class="commission__resumeInfo">
          <div class="title">
            <h2>Mis comisiones acumuladas</h2>
          </div>
          <div class="info">
            <i class="pi pi-money-bill"></i>
            <h3>{{ listCommissionsAcumulated | currency: '' : '': '1.0-1' }}</h3>
            <sup>{{ environment.global.country.currency }}</sup>
          </div>
        </div>

        <div class="commission__resumeAlert" *ngIf="requestPaymentStatus === true">
          <p>Actualmente posees una solicitud de pago abierta.</p>
        </div>

        <div class="commission__resumeBtn" *ngIf="requestPaymentStatus === false && listCommissionsAcumulated >= environment.global.country.minAmountRequestCommissionPayment">
          <button pButton pRipple label="Solicitar pago" icon="pi pi-wallet" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded min-pad" (click)="confirmRequestPayment()"></button> 
        </div>
      </div>
    </div>

    <div class="commission__block">
      <div class="dashboard__reports">
        <div class="boxCard w-full">
          <div class="boxCard__header">
            <h3>Últimas ventas y comisiones</h3>
          </div>
          <div class="boxCard__content">    
            <p-table [value]="commissions" styleClass="p-datatable" id="table_commissions">
              <ng-template pTemplate="header">
                <tr>
                  <th>Marca</th>
                  <th>Comisión</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-commission>
                <tr>
                  <td>
                    <div class="datatable__info">
                      <i class="pi pi-mobile"></i>
                      <div class="datatable__infoText">
                        <p>{{commission.brand.name}}</p>
                        <span>{{commission.date | date: 'short'}}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="datatable__value">
                      <p>{{commission.amount | currency}}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="datatable__footerBtn">
                  <button pButton pRipple label="Ver más comisiones" icon="pi pi-eye" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" [routerLink]="['/comisiones/reportes']"></button> 
                </div>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Su solicitud ha sido recibida</h2>
          <p>En las próximas 24 horas se estará haciendo efectivo su pago.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Aceptar" icon="pi pi-check" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visible=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="confirmVisible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Confirmación</h2>
          <p>¿Está seguro que desea solicitar el pago?</p>
        </div>
        <div class="dialog__btn dialog__btn--flex">
          <div class="item">
            <button pButton pRipple label="No" icon="pi pi-times" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded w-full" (click)="confirmVisible=false"></button>
          </div>
          <div class="item">
            <button pButton pRipple label="Si" icon="pi pi-check" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="requestPayment()"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>